// extracted by css-extract-rspack-plugin
export default {"root":"root-mMgOxZ","hover":"hover-xCh5sN","pressed":"pressed-AUDWq9","disabled":"disabled-j0i1ay","focusVisible":"focusVisible-_0dWaf"};